export default __webpack_public_path__ + "static/media/Asset 10.83d7e837.png";